var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgriculture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 19,
    viewBox: "0 0 12 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12C9.28379 11.6192 10.4896 10.4333 11 6C7.64707 6.32851 6.07381 8.23251 6 12ZM6 12C2.71621 11.6192 1.51037 10.4333 1 6C4.35293 6.32851 5.92619 8.23251 6 12ZM6 18C9.28379 17.6192 10.4896 16.4333 11 12C7.64707 12.3285 6.07381 14.2325 6 18ZM6 18C2.71621 17.6192 1.51037 16.4333 1 12C4.35293 12.3285 5.92619 14.2325 6 18ZM6 6V0M8 4.5V1.5M4 4.5V1.5",
    stroke: "#118F84",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgriculture);
export default __webpack_public_path__ + "static/media/AGRICULTURE.b03e3be1c35f33e0efb86d391dc55644.svg";
export { ForwardRef as ReactComponent };